<ml-mdm-command-spinner [commandProgress]="commandProgress$">
  <ml-mdm-notifications-profile [(notificationsProfile)]="notificationsProfile"
                                [mutate]="true"></ml-mdm-notifications-profile>

  <p class="text-end">
    <button class="btn btn-link px-0"
            (click)="showMore = !showMore">more</button>
  </p>
  <div [class.collapse]="!showMore">
    <ml-mdm-configuration-payload [(payloadContent)]="notificationsProfile"
                                  [mutate]="true"></ml-mdm-configuration-payload>
    <ml-mdm-configuration-profile [(configurationProfile)]="configurationProfile"
                                  [mutate]="true"></ml-mdm-configuration-profile>
  </div>

  <button type="submit"
          class="btn btn-primary"
          (click)="installProfile(udid())">
    <fa-icon icon="file-upload"></fa-icon>
    <span class="ms-2"
          i18n>Install</span>
  </button>
</ml-mdm-command-spinner>